// import React, { useEffect, useState } from "react";
import React, { useEffect, useState } from "react";
import css from "./VenueListingDetails.module.scss";
import curtainsImage from "../../assets/Images/Icons/curtains.png";
import projectorIcon from "../../assets/Images/Icons/projector.png";
import audioIcon from "../../assets/Images/Icons/audio-equipment.png";
import microphoneIcon from "../../assets/Images/Icons/microphone.png";
import parkingIcon from "../../assets/Images/Icons/parking.png";
import capacityIcon from "../../assets/Images/Icons/capacity.png";
import lightIcon from "../../assets/Images/Icons/light.png";
import consoleIcon from "../../assets/Images/Icons/console.png";
import screenIcon from "../../assets/Images/Icons/screen.png";
import cafeteriaIcon from "../../assets/Images/Icons/cafeteria.png";
import ticketIcon from "../../assets/Images/Icons/ticket.png";
import toiletIcon from "../../assets/Images/Icons/toilet.png";
import wardrobeIcon from "../../assets/Images/Icons/wardrobe.png";
import bookshopIcon from "../../assets/Images/Icons/bookshop.png";
import { useDispatch, useSelector } from "react-redux";
import BookingForm from "./BookingForm/BookingForm";
import LoadingPage from "../../containers/LoadingPage/LoadingPage";
// import { FULFILLED } from "../../constants/data";
import classNames from "classnames";
import FormatText from "../FormatText/FormatText";
import { loadUser } from "../../redux/reducers/authSlice";
import { fetchCurrentUserAllListing } from "../../redux/reducers/listingSlice";
import { getSubscription } from "../../redux/reducers/subscriptionSlice";
// import IconCollection from "../IconCollection/IconCollection";

const VenueListingDetails = () => {
  const dispatch = useDispatch();
  const { currentListing: listingData } = useSelector((state) => state.listing);
  const [userListings, setUserlistings] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    venue_name,
    // cover_image,
    // additional_media,
    description,
    venue_tag,
    expect_dates,
    except_days,
    active_days,
    artistic_director_email,
    artistic_director_phone_number,
    technical_director_email,
    technical_director_phone_number,
    stage_dimension_length,
    stage_dimension_width,
    stage_dimension_height,
    stage_dimension_slope,
    stage_dimension_max_weight_capacity,
    total_capacity,
    pit_seated_audience,
    pit_standing_audience,
    gallery_capacity,
    projector_model,
    screen,
    screen_model,
    light_system,
    sound_system,
    console_model,
    audio_equipment_model,
    unload_access,
    dressing_rooms,
    bathrooms,
    cafeteria,
    ticket_office,
    toilets,
    wardrobe,
    bookshop,
    parking_for_companies,
    parking_for_companies_count,
    parking_for_customers,
    parking_for_customers_count,
    planimetry,
    seatings_map,
    permits,
    projector,
    // power_outage,
    price_for_one_event,
    price_for_rehearsals,
    venue_location,
    currency,
    staff_rate,
    // sound_engineer,
    minimum_booking_fee,
    user_id,
  } = listingData ?? {};
  const currencySymbol = currency?.split("-")[0];

  useEffect(() => {
    async function fetchUser() {
      setLoading(true);
      dispatch(getSubscription());
      await dispatch(loadUser());
      const userListing = await dispatch(fetchCurrentUserAllListing());
      if (userListing?.meta?.requestStatus === "fulfilled")
        setUserlistings(userListing?.payload?.data);
      setLoading(false);
    }
    fetchUser();
  }, [dispatch]);

  const priceForTechnicalInstruments = Object.keys(listingData ?? {})
    ?.filter((e) => e.includes("price_for_technical_instruments"))
    ?.map((key) => {
      return { key, price: +listingData[key], qty: 0 };
    });

  const priceForAdditionalStaff = Object.keys(listingData ?? {})
    ?.filter((e) => e.includes("price_for_additional_staff"))
    ?.map((key) => {
      return { key, price: +listingData[key], qty: 0 };
    });

  const packages =
    dressing_rooms ||
    bathrooms ||
    cafeteria ||
    ticket_office ||
    toilets ||
    wardrobe ||
    bookshop;
  const parking = parking_for_companies || parking_for_customers;
  return (
    <div className={css.listingDetailsWrapper}>
      {listingData?.id ? (
        <>
          <div className={css.contentWrapper}>
            <div className={css.leftContents}>
              <h1 className={css.venueTitle}>{venue_name}</h1>
              <p className={css.addressText}>
                {venue_location?.formatted_address}
              </p>

              <div className={css.venueTag}>
                <p> {venue_tag}</p>
              </div>
              {description && (
                <div>
                  <h2 className={css.subTitle}>Description</h2>
                  <p>{description}</p>
                </div>
              )}
              <h2 className={css.subTitle}>Capacity</h2>
              <ul>
                {total_capacity && (
                  <li>
                    <span className={css.boldText}>Total capacity: </span>
                    {total_capacity}
                  </li>
                )}
                {pit_standing_audience && (
                  <li>
                    <span className={css.boldText}>
                      Pit standing audience:{" "}
                    </span>
                    {pit_standing_audience}
                  </li>
                )}
                {pit_seated_audience && (
                  <li>
                    <span className={css.boldText}>Pit seated audience: </span>
                    {pit_seated_audience}
                  </li>
                )}
                {gallery_capacity && (
                  <li>
                    <span className={css.boldText}>Gallery capacity: </span>
                    {gallery_capacity}
                  </li>
                )}
              </ul>
              <h2 className={css.subTitle}>Stage</h2>
              <ul>
                {stage_dimension_length && (
                  <li>
                    <span className={css.boldText}>Length : </span>
                    {stage_dimension_length} meters
                  </li>
                )}
                {stage_dimension_width && (
                  <li>
                    <span className={css.boldText}>Width : </span>
                    {stage_dimension_width} meters
                  </li>
                )}
                {stage_dimension_height && (
                  <li>
                    <span className={css.boldText}>Height : </span>
                    {stage_dimension_height} meters
                  </li>
                )}
                {stage_dimension_slope && (
                  <li>
                    <span className={css.boldText}>Slope : </span>
                    {stage_dimension_slope} meters
                  </li>
                )}
                {stage_dimension_max_weight_capacity && (
                  <li>
                    <span className={css.boldText}>Max Weight capacity : </span>
                    {stage_dimension_max_weight_capacity} kgs.
                  </li>
                )}
              </ul>
              <h2 className={css.subTitle}>Contacts</h2>
              <ul>
                {artistic_director_email && (
                  <li>
                    <span className={css.boldText}>
                      Artistic Director Email :{" "}
                    </span>
                    {artistic_director_email}
                  </li>
                )}
                {artistic_director_phone_number && (
                  <li>
                    <span className={css.boldText}>
                      Artistic Director Phone Number :{" "}
                    </span>
                    {artistic_director_phone_number}
                  </li>
                )}
                {technical_director_email && (
                  <li>
                    <span className={css.boldText}>
                      Technical Director Email :{" "}
                    </span>
                    {technical_director_email}
                  </li>
                )}
                {technical_director_phone_number && (
                  <li>
                    <span className={css.boldText}>
                      Technical Director Phone Number :{" "}
                    </span>
                    {technical_director_phone_number}
                  </li>
                )}
              </ul>
            </div>
            {loading ? (
              <LoadingPage />
            ) : (
              <BookingForm
                currency={currencySymbol}
                authorId={user_id}
                staff_rate={staff_rate}
                userListings={userListings}
                priceForAdditionalStaff={priceForAdditionalStaff}
                priceForTechnicalInstruments={priceForTechnicalInstruments}
                price_for_one_event={price_for_one_event}
                price_for_rehearsals={price_for_rehearsals}
                expect_dates={expect_dates}
                active_days={active_days}
                except_days={except_days}
                minimum_booking_fee={minimum_booking_fee}
              />
            )}
          </div>

          {/* availableAccessories */}
          <div className={css.availableAccessories}>
            <h1 className={css.title}>Available accessories</h1>
            <div className={css.accessoriesContents}>
              <div className={css.accessoriesColumn}>
                {screen && (
                  <div className={css.accessoriesContent}>
                    <img src={screenIcon} alt="screenIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Screen Model: </span>
                        {screen_model}
                      </p>
                    </div>
                  </div>
                )}
                {projector && (
                  <div className={css.accessoriesContent}>
                    <img src={projectorIcon} alt="projectorIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Projector Model: </span>
                        {projector_model}
                      </p>
                    </div>
                  </div>
                )}
                {light_system && (
                  <div className={css.accessoriesContent}>
                    <img src={lightIcon} alt="lightIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Light System: </span>
                        {light_system}{" "}
                      </p>
                    </div>
                  </div>
                )}
                {sound_system && (
                  <div className={css.accessoriesContent}>
                    <img src={audioIcon} alt="audioIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Sound System: </span>
                        {sound_system}{" "}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className={css.accessoriesColumn}>
                {console_model && (
                  <div className={css.accessoriesContent}>
                    <img src={consoleIcon} alt="consoleIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Console Model: </span>
                        {console_model}{" "}
                      </p>
                      <p></p>
                    </div>
                  </div>
                )}
                {audio_equipment_model && (
                  <div className={css.accessoriesContent}>
                    <img src={microphoneIcon} alt="microphoneIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>
                          Audio Equipment Model:{" "}
                        </span>
                        {audio_equipment_model}{" "}
                      </p>
                      <p></p>
                    </div>
                  </div>
                )}

                {unload_access && (
                  <div className={css.accessoriesContent}>
                    <img src={capacityIcon} alt="capacityIcon" />
                    <div>
                      <p>
                        <span className={css.boldText}>Unload Access: </span>
                        {unload_access ? "Available" : "Not Available"}{" "}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Hospitality */}

          <div className={css.hospitalityWrapper}>
            {(packages || parking) && (
              <h1 className={classNames(css.title, css.titleHospitality)}>
                Hospitality
              </h1>
            )}
            <div className={css.hospitalityColumns}>
              <div className={css.hospitalityColumn}>
                {packages && <h2 className={css.subTitle}>Package</h2>}
                <div className={css.hospitalityContents}>
                  {dressing_rooms && (
                    <div className={css.hospitalityContent}>
                      <img src={curtainsImage} alt="" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Dressing Rooms: </span>
                        {dressing_rooms}
                      </p>
                    </div>
                  )}
                  {bathrooms && (
                    <div className={css.hospitalityContent}>
                      <img src={toiletIcon} alt="" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Bath Rooms: </span>
                        {bathrooms}
                      </p>
                    </div>
                  )}
                  {cafeteria && (
                    <div className={css.hospitalityContent}>
                      <img src={cafeteriaIcon} alt="Icon" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Cafeteria: </span>
                        {cafeteria}
                      </p>
                    </div>
                  )}
                  {ticket_office && (
                    <div className={css.hospitalityContent}>
                      <img src={ticketIcon} alt="Icon" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Ticket Office: </span>
                        {ticket_office}
                      </p>
                    </div>
                  )}
                  {toilets && (
                    <div className={css.hospitalityContent}>
                      <img src={toiletIcon} alt="Icon" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Toilets: </span>
                        {toilets}
                      </p>
                    </div>
                  )}
                  {wardrobe && (
                    <div className={css.hospitalityContent}>
                      <img src={wardrobeIcon} alt="Icon" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Wardrobe: </span>
                        {wardrobe ? FormatText("Yes") : FormatText("No")}
                      </p>
                    </div>
                  )}
                  {bookshop && (
                    <div className={css.hospitalityContent}>
                      <img src={bookshopIcon} alt="Icon" />
                      <p>
                        {" "}
                        <span className={css.textBold}>Bookshop: </span>
                        {bookshop ? FormatText("Yes") : FormatText("No")}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {parking ? (
                <div className={css.hospitalityColumn}>
                  <h2 className={css.subTitle}>Parking</h2>
                  <div className={css.hospitalityContents}>
                    {parking_for_companies && (
                      <div className={css.hospitalityContent}>
                        <img src={parkingIcon} alt="Icon" />
                        <p>
                          {" "}
                          <span className={css.textBold}>
                            Parking for Companies:{" "}
                          </span>
                          {parking_for_companies_count}
                        </p>
                      </div>
                    )}
                    {parking_for_customers && (
                      <div className={css.hospitalityContent}>
                        <img src={parkingIcon} alt="Icon" />
                        <p>
                          {" "}
                          <span className={css.textBold}>
                            Parking for Customers:{" "}
                          </span>
                          {parking_for_customers_count}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {(planimetry?.url || seatings_map?.url || permits?.url) && (
            <div className={css.fileAttachments}>
              <h1 className={css.title}>File attachments</h1>
              <div className={css.attachmentsContents}>
                {planimetry?.url && (
                  <div className={css.attachmentsContent}>
                    <p className={css.attachmentsText}>Planimetry - </p>
                    <a
                      className={css.linkText}
                      target="_blank"
                      rel="noreferrer"
                      href={planimetry?.url}
                    >
                      {planimetry?.url && "Link"}
                    </a>
                  </div>
                )}
                {seatings_map?.url && (
                  <div className={css.attachmentsContent}>
                    <p className={css.attachmentsText}>Map - </p>
                    <a
                      className={css.linkText}
                      target="_blank"
                      rel="noreferrer"
                      href={seatings_map?.url}
                    >
                      {seatings_map?.url && "Link"}
                    </a>
                  </div>
                )}
                {permits?.url && (
                  <div className={css.attachmentsContent}>
                    <p className={css.attachmentsText}>Permits - </p>
                    <a
                      className={css.linkText}
                      target="_blank"
                      rel="noreferrer"
                      href={permits?.url}
                    >
                      {permits?.url && "Link"}
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* LocationWrapper */}
          {venue_location?.place_id ? (
            <div className={css.locationWrapper}>
              <div className={css.mapContents}>
                <h1 className={css.title}>Location</h1>
                <div className={css.mapBox}>
                  <iframe
                    title="Location"
                    width="600"
                    height="450"
                    style={{ border: 0 }}
                    referrerPolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=place_id:${venue_location?.place_id}`}
                  ></iframe>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <LoadingPage />
      )}
    </div>
  );
};

export default VenueListingDetails;
